var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-stepped',{ref:"page",attrs:{"title":_vm.$t('Imports_Title_CreateImport'),"steps":_vm.steps,"model":_vm.model,"fetch-endpoint":_vm.fetchEndpoint,"save-endpoint":_vm.saveEndpoint,"rules":_vm.rules,"save-button":_vm.$t('Imports_Button_RunImport'),"breadcrumbs":_vm.breadcrumbs,"after-save":_vm.afterSave}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d877861","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/imports/pages/ImportFormPage.vue
// module id = null
// module chunks = 